import { render, staticRenderFns } from "./AiTabNav.vue?vue&type=template&id=08117b31&scoped=true&"
import script from "./AiTabNav.vue?vue&type=script&lang=js&"
export * from "./AiTabNav.vue?vue&type=script&lang=js&"
import style0 from "./AiTabNav.vue?vue&type=style&index=0&id=08117b31&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08117b31",
  null
  
)

export default component.exports